const MenuGN =  [
{
    title: 'Cajero GN',
    group: 'cajeroGN',
    component: 'cajeroGN',
    icon: 'add_circle_outline',
    roles: [ 1,4 ],
    items: [
      { name: 'NuevoCajeroGN', title: 'Nuevo', component: 'CajeroCreateGN', roles: [ 1,2,4 ] },
      { name: 'ListadoCajeroGN', title: 'Listado', component: 'CajeroListadoGN', roles: [ 1,2,4 ] },
    ]
  },
  {
    title: 'Trámites GN',
    group: 'data',
    component: 'newDataGN',
    icon: 'add_circle_outline',
    roles: [ 1,2,4 ],
    items: [
      { name: 'Gestiones', title: 'Gestiones', component: 'dataCreateGN', roles: [ 1,2,4 ] },
      { name: 'Historial', title: 'Historial', component: 'dataHistoryGN', roles: [ 1,2,4 ] },
      { name: 'Agentes',title: 'Archivos', component: 'AgentesGN' ,roles: [ 1,2,4 ],},
      {children:[{
        name: 'Agentes',title: 'Archivos', component: 'AgentesGN' ,roles: [ 1,2,4 ]
      }]}
    ]
  },
  {
    title: 'Documentos GN',
    group: 'archivo',
    icon: 'person',
    roles: [ 1,3,4 ],
    items: [
      {name: 'Nuevo', title: 'Nuevo', component: 'agenteArchivoCrearGN', roles: [ 1,3,4 ] },
      {name: 'Historial', title: 'Historial', component: 'agenteArchivoHistoriaGN', roles: [ 1,3,4 ] },
      {name: 'Archivos', title: 'Archivos', component: 'ArchivosGN', roles: [ 1,3,4 ] },
    ]
  }

];

export default MenuGN;
